"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Code = void 0;
/**
 * Represents code information
 */
var Code = /** @class */ (function (_super) {
    __extends(Code, _super);
    function Code() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Code";
        /**
         * The code id
         */
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        /**
         * The code reference id
         */
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        /**
         * The name of the code
         */
        _this.qualifier = function () {
            _this.push(function (_) { return "qualifier"; });
        };
        /**
         * Detailed description about the code
         */
        _this.appendent = function () {
            _this.push(function (_) { return "appendent"; });
        };
        /**
         * The code dictionary. The key is a file name and the value is the code
         */
        _this.code = function () {
            _this.push(function (_) { return "code"; });
        };
        /**
         * The list of labels of the code
         */
        _this.labelList = function () {
            _this.push(function (_) { return "labelList"; });
        };
        /**
         * The type of the code
         */
        _this.type = function () {
            _this.push(function (_) { return "type"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Code;
}(Array));
exports.Code = Code;
//# sourceMappingURL=Code.js.map